import { FC } from "react";
import { WORKSPACE_ROLES_LABELS } from "@common/constants";
import { UserAvatar } from "@components/user/UserAvatar";
import { IconList } from "@components/general/IconList/IconList";
import { IconWithTooltip } from "@components/general/IconList/IconWithTooltip";
import { WorkspaceAssignment } from "@common/types/workspace";

interface TeamListProps {
    team: WorkspaceAssignment[];
}

export const TeamList: FC<TeamListProps> = ({ team }) => (
    <IconList
        items={team}
        maxItems={Number.MAX_VALUE}
        renderItem={({ user, role }, { index }) => (
            <IconWithTooltip
                tooltipId={`workspace-assignment-tooltip-${user?.id ?? index}`}
                tooltip={
                    <>
                        <strong>{user?.name}</strong> <br />
                        {WORKSPACE_ROLES_LABELS[role]}
                    </>
                }
            >
                <UserAvatar user={user} size="xs" />
            </IconWithTooltip>
        )}
    />
);
